/**
 * dashboard.ts — chamadas tipadas do dashboard (F4).
 */

import type { components } from './generated/api'
import { api, apiComMeta, type Paginacao } from './http'

export type ResumoDashboard = components['schemas']['ResumoDashboard']
export type ItemProcesso = components['schemas']['ItemProcesso']

export function resumoDashboard() {
  return api<ResumoDashboard>('/api/v1/dashboard/resumo')
}

export interface FiltroItens {
  busca?: string
  dominio?: string
  pagina?: number
  porPagina?: number
}

// /processos é paginado: o wrapper devolve só o data; aqui precisamos do
// meta.paginacao também — chamada dedicada preservando o envelope
export async function listarItens(filtro: FiltroItens): Promise<{
  itens: ItemProcesso[]
  paginacao: Paginacao
}> {
  const parametros = new URLSearchParams()
  if (filtro.busca) parametros.set('busca', filtro.busca)
  if (filtro.dominio && filtro.dominio !== 'all')
    parametros.set('dominio', filtro.dominio)
  parametros.set('pagina', String(filtro.pagina ?? 1))
  parametros.set('por_pagina', String(filtro.porPagina ?? 20))

  const resposta = await apiComMeta<ItemProcesso[]>(
    `/api/v1/processos?${parametros.toString()}`,
  )
  return { itens: resposta.data, paginacao: resposta.meta.paginacao! }
}
